export default __webpack_public_path__ + "static/media/2.9b3acc80.jpg";